import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/data";
import { Reveal, Eyebrow } from "@/components/site/Reveal";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="scroll-mt-20 bg-[#050505] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="mb-14 grid grid-cols-1 items-end gap-6 md:grid-cols-12">
          <div className="md:col-span-8">
            <Reveal><Eyebrow>What we do</Eyebrow></Reveal>
            <Reveal i={1}>
              <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.02] tracking-tighter text-[#f5f5f0] sm:text-5xl lg:text-6xl">
                Remediation, delivered properly.
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-[#8a8a8a]">
                Responsive attendance with qualified technicians on every job.
              </p>
            </Reveal>
          </div>
          <Reveal i={2} className="md:col-span-4">
            <p className="text-base leading-relaxed text-[#8a8a8a]">
              Each engagement follows a structured methodology, with controls
              and documentation in place to support accountable results.
            </p>
          </Reveal>
        </div>

        <div className="hairline-grid grid grid-cols-1 gap-px border border-[#2a2a2a] md:grid-cols-12">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.id}
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.id}`}
                className={`group relative flex min-h-[240px] flex-col justify-between p-8 transition-colors duration-500 hover:bg-[#121212] ${s.span}`}
              >
                <div className="flex items-start justify-between">
                  <Icon
                    className="h-9 w-9 text-[#c4a962] transition-transform duration-500 group-hover:scale-110"
                    strokeWidth={1.5}
                  />
                </div>
                <div>
                  <h3 className="font-display text-2xl font-medium leading-tight tracking-tight text-[#f5f5f0] md:text-[1.7rem]">
                    {s.title}
                  </h3>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-[#8a8a8a]">
                    {s.desc}
                  </p>
                </div>
                <ArrowUpRight className="absolute right-8 top-1/2 h-6 w-6 -translate-y-1/2 text-[#f5f5f0] opacity-0 transition-all duration-500 group-hover:opacity-100" />
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
